// Centralized query keys, kept hierarchical so partial invalidations work cleanly.
export const qk = {
  auth: ["auth"] as const,
  me:   () => [...qk.auth, "me"] as const,

  mail: ["mail"] as const,
  mailbox: (id: string) => [...qk.mail, "mailbox", id] as const,
  mailThreads: (account: string, mailbox: string, filter?: unknown) => [...qk.mail, "threads", account, mailbox, filter] as const,
  mailThread:  (account: string, thread: string) => [...qk.mail, "thread", account, thread] as const,
  mailEmail:   (account: string, id: string) => [...qk.mail, "email", account, id] as const,
  mailTelemetry: (rfc822: string, tracking?: string) => [...qk.mail, "telemetry", rfc822, tracking ?? null] as const,
  mailHealth:  (window_days: number) => [...qk.mail, "health", window_days] as const,

  support: ["support"] as const,
  supportInboxes: () => [...qk.support, "inboxes"] as const,
  supportAgents:  () => [...qk.support, "agents"] as const,
  supportTickets: (filter?: unknown) => [...qk.support, "tickets", filter] as const,
  supportTicket:  (id: string) => [...qk.support, "ticket", id] as const,
  supportMessages: (id: string) => [...qk.support, "messages", id] as const,
  supportActivity: (id: string) => [...qk.support, "activity", id] as const,

  files: ["files"] as const,
  filesList:  (folder_id: string | null) => [...qk.files, "list", folder_id] as const,
  fileOne:    (id: string) => [...qk.files, "one", id] as const,
  fileShares: (id: string) => [...qk.files, "shares", id] as const,
  folders:    (parent: string | null) => [...qk.files, "folders", parent] as const,

  calendar: ["calendar"] as const,
  calendars: () => [...qk.calendar, "list"] as const,
  events:    (range: { start_ts: number; end_ts: number }, calendars?: string[]) => [...qk.calendar, "events", range, calendars] as const,
  eventAttendees: (event_id: string) => [...qk.calendar, "attendees", event_id] as const,

  meetings: ["meetings"] as const,
  meetRoom: (id: string) => [...qk.meetings, "room", id] as const,
  recordings: () => [...qk.meetings, "recordings"] as const,
  recording:  (id: string) => [...qk.meetings, "recording", id] as const,
};
